export type TextStyle = 'largeTitle' | 'title1' | 'title2' | 'title3' | 'headline' | 'body' |
	'callout' | 'subhead' | 'footnote' | 'caption1' | 'caption2'

export default (theme: any = {}) => {
    const { fonts, fontSizes, fontWeights, lineHeights, letterSpacings } = theme

    return {
        largeTitle: {
			fontFamily: fonts.hero,
            fontSize: `${fontSizes[9] || 72}px`,
            lineHeight: lineHeights.heading
        },
        title1: {
            fontSize: `${fontSizes[8]}px`,
            lineHeight: lineHeights.heading
        },
        title2: {
            fontSize: `${fontSizes[7]}px`,
            lineHeight: lineHeights.heading
        },
        title3: {
            fontSize: `${fontSizes[6]}px`,
            lineHeight: lineHeights.heading
		},
        headline: {
            fontSize: `${fontSizes[5]}px`,
            lineHeight: lineHeights.standard
		},
		subhead: {
            fontSize: `${fontSizes[4]}px`,
            lineHeight: lineHeights.standard
        },
        body: {
            fontSize: `${fontSizes[3]}px`,
            lineHeight: lineHeights.standard
        },
        callout: {
            fontSize: `${fontSizes[2]}px`,
            lineHeight: lineHeights.standard
        },
        footnote: {
            fontSize: `${fontSizes[1]}px`,
            lineHeight: lineHeights.standard
        },
        caption1: {
            fontSize: `${fontSizes[1]}px`,
            lineHeight: lineHeights.standard
        },
        caption2: {
            fontSize: `${fontSizes[0]}px`,
            lineHeight: lineHeights.standard
		},
		label: {
			fontFamily: fonts.label,
			fontSize: `${fontSizes[2]}px`,
			letterSpacing: `${letterSpacings.caps}`,
			textTransform: 'uppercase'
		},
		value: {
			fontFamily: fonts.heading
		}
    }
}
